import * as React from 'react';
import { FormControl, Input } from '@SBGSports/referee-react';
import { ICellRendererParams } from 'ag-grid-community';
import { IconRemove } from '@SBGSports/referee-react/icons';
import { useState } from 'react';
import { kebabCase } from 'lodash';

export interface CellInputProps {
    value: string | undefined;
    onChange: ((value: string) => void) | undefined;
    params: ICellRendererParams;
    placeholder: string;
}

const getInputId = (tagName: string) => {
    return kebabCase(tagName.toLowerCase());
};

export const CellInput: React.FC<CellInputProps> = (props) => {
    const { value, onChange, params, placeholder } = props;

    // State
    const [name, setName] = useState<string>(value ?? '');

    return (
        <FormControl fullWidth>
            <Input
                data-testid={`${getInputId(params.node.data.tags)}-input`}
                id={`${getInputId(params.node.data.tags)}-input`}
                value={name}
                placeholder={placeholder}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setName(event.target.value);
                }}
                onBlur={() => {
                    if (params.node.isSelected() && !name) {
                        onChange?.(params.node.data.tags);
                        setName(params.node.data.tags);
                    } else if (name) {
                        onChange?.(name);
                        params.node.setData({ ...params.node.data, annotation: name });
                        params.node.setSelected(true);
                    }
                }}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                        setName(name);
                        onChange?.(name);
                    }
                    if (event.key === 'Escape') {
                        if (params.node.isSelected()) {
                            setName(params.node.data.tags);
                        } else {
                            setName('');
                        }
                    }
                }}
                size={'small'}
                endAdornmentSlot={
                    name ? (
                        <IconRemove
                            data-testid={`${getInputId(params.node.data.tags)}-input-clear`}
                            style={{
                                pointerEvents: 'all',
                                cursor: 'pointer',
                            }}
                            onMouseDown={() => {
                                if (!params.node.isSelected()) {
                                    setName('');
                                }
                            }}
                            onClick={() => {
                                if (params.node.isSelected()) {
                                    setName('');
                                    document.getElementById(`${getInputId(params.node.data.tags)}-input`)?.focus();
                                }
                            }}
                        />
                    ) : (
                        <div />
                    )
                }
            />
        </FormControl>
    );
};
